import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './DiagnosticCentreComponent.module.scss';
import metadata from './DiagnosticCentreComponent.metadata.json5';

function DiagnosticCentreComponent(props) {

    const {
        data: DiagnosticCentreComponentVM,
        updateWizardData,
        submissionVM,
        DiagnosticCentreComponentPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    const addDiagnosticCentre = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            DiagnosticCentreComponentVM.value = DiagnosticCentreComponentVM.value || []

            const { _xCenter, _dtoName } = DiagnosticCentreComponentVM;

            const DiagnosticCentreObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            DiagnosticCentreObjVM.value.perOfRev2 = 0
            DiagnosticCentreObjVM.value.annNumOfPro3 = 0

            DiagnosticCentreComponentVM.pushElement(
                DiagnosticCentreObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, DiagnosticCentreComponentVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            DiagnosticCentreComponentVM.value.splice(index, 1);
            _.set(submissionVM.value, DiagnosticCentreComponentPath, DiagnosticCentreComponentVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, DiagnosticCentreComponentPath, DiagnosticCentreComponentVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'diaCen1') {
                const value = (item && item.diaCen1) ? item.diaCen1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = DiagnosticCentreComponentVM.length > 0 && DiagnosticCentreComponentVM.children[index].diaCen1
                    // eslint-disable-next-line security/detect-object-injection
                    ? DiagnosticCentreComponentVM.children[index].diaCen1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.diaCen1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'perOfRev2') {
                const value = item.perOfRev2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'annNumOfPro3') {
                const value = item.annNumOfPro3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.annNumOfPro3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des4' && !_.isUndefined(item.diaCen1) && item.diaCen1 === 'Other') {
                const value = item.des4 ? item.des4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange, translator, DiagnosticCentreComponentVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`DiagnosticCentreTable`]: {
            data: DiagnosticCentreComponentVM.value,
        }

    }), [DiagnosticCentreComponentVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addDiagnosticCentre,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            DiagnosticCentreComponentVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [DiagnosticCentreComponentVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={DiagnosticCentreComponentVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

DiagnosticCentreComponent.propTypes = wizardProps;
export default withRouter(DiagnosticCentreComponent);
